function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


window.getCookie = function(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}
window.setCookie = function(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/;SameSite=Lax";
}

var htmlE = document.documentElement,
    isInv = (window.getCookie("isInv") == "yes") ? true : false,
    showProdEl = document.querySelector("input#image_view_product"),
    showOutEl = document.querySelector("input#image_view_outfit");
    //
if (isInv && showOutEl && htmlE) {
    htmlE.classList.add("img-inv");
    showOutEl.checked = true;
}
function checkImgInv() {
    var isInv = (document.querySelector("input#image_view_outfit:checked")) ? true : false,
        htmlE = document.documentElement;
    if (isInv) {
        htmlE.classList.add("img-inv");
        window.setCookie("isInv", "yes", 7);
    } else {
        htmlE.classList.remove("img-inv");
        window.setCookie("isInv", "no", 7);
    }
}
if (showProdEl) {
    showProdEl.addEventListener('change', function() {
        checkImgInv();
    });
}
if (showOutEl) {
    showOutEl.addEventListener('change', function() {
        checkImgInv();
    });
}

function forwardSlider(anSlider, firstRun) {
    if (firstRun) {
        if (anSlider.getAttribute("data-count") == "0" || anSlider.getAttribute("data-count") == "1") {
            return;
        }
        anSlider.querySelector(".announcement-bar:first-child").classList.add("active");
        anSlider.classList.add("loaded");
        anSlider.classList.remove("onload");

        setTimeout(() => { forwardSlider(anSlider, false) }, 5000);
    }
    let curActive = anSlider.querySelector(".announcement-bar.active");
    let nextActive = curActive.nextElementSibling;
    nextActive ||= anSlider.querySelector(".announcement-bar:first-child");

    curActive.classList.add("fadeOut");    
    nextActive.classList.add("fadeIn");
    setTimeout(() => { nextActive.classList.add("active"); curActive.classList.remove("active"); }, 300);
    setTimeout(() => { nextActive.classList.remove("fadeIn"); curActive.classList.remove("fadeOut"); }, 800);

    setTimeout(() => { forwardSlider(anSlider, false) }, 5000);
}

document.querySelectorAll(".announcement-slider-wrapper").forEach((anSlider) => {
    forwardSlider(anSlider, true);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.parentElement.parentElement.parentElement.querySelectorAll('.product__accordion [id^="Details-"]').forEach((details) => {
        //console.log("loop");
        if (!event.currentTarget.closest('details').hasAttribute('open') && event.currentTarget.closest('details').id != details.id) {
            details.removeAttribute('open');
            details.setAttribute('aria-expanded', false);
        }
    });
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      //if (window.matchMedia('(max-width: 1075px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      //}
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 100);
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

function checkInch(modal) {
    var isInch = (modal.querySelector("input.sizeguide_inch:checked")) ? true : false,
        htmlE = document.documentElement;
    if (isInch) {
        htmlE.classList.add("inch");
        window.setCookie("isInch", "yes", 7);
    } else {
        htmlE.classList.remove("inch");
        window.setCookie("isInch", "no", 7);
    }
}

function sizeGuideInit(modal) {
    if (modal.querySelector("input.sizeguide_inch") != null && modal.querySelector("input.sizeguide_cm") != null) {
        if (window.getCookie("isInch") == "yes" && document.documentElement) {
            document.documentElement.classList.add("inch");
            modal.querySelector("input.sizeguide_inch").checked = true;
        } else {
            modal.querySelector("input.sizeguide_cm").checked = true;
        }
        modal.querySelector("input.sizeguide_cm").addEventListener('change', function() {
            checkInch(modal);
        });
        modal.querySelector("input.sizeguide_inch").addEventListener('change', function() {
            checkInch(modal);
        });
    
        const myTable = modal.querySelector(".sizeguide-table table");
        const cols = myTable.querySelectorAll("col");
        const rows = myTable.querySelectorAll("rows");
        const events = {
            mouseover: e => {
                const t = e.target.closest("td");
                if (t) {

                    // const cellIndex = t.cellIndex;
                    // for (let i = 0, n = cols.length; i < n; i++) {
                    //     cols[i].classList[i === cellIndex ? "add" : "remove"]("hovered");
                    // }
                    // for (let i = 0, n = rows.length; i < n; i++) {
                    //     // rows[i].classList[i === cellIndex ? "add" : "remove"]("hovered");
                    //     let curcelrow = rows[i].querySelector("td");
                    //     for (let p = 0, t = rows.length; p < t; p++) {
                    //         curcelrow.classList[p === cellIndex ? "add" : "remove"]("hovered");
                    //     }

                    // }
                    if (myTable.getAttribute("data-highlight") != t.cellIndex) {
                        myTable.setAttribute("data-highlight", t.cellIndex);
                    }
                }
            },
            mouseout: e => {
                // const t = e.target;
                // if (t.nodeName === "TD" && !t.contains(e.relatedTarget)) {
                //     cols[t.cellIndex].classList.remove("hovered");
                // }
                myTable.setAttribute("data-highlight", 0);
            },
            click: e => {
                e.preventDefault();
                let allIndexCells = myTable.querySelectorAll("td[data-index]");
                for (let i = 0, n = allIndexCells.length; i < n; i++) {
                    allIndexCells[i].classList.remove("clicked");
                }
                const t = e.target.closest("td");
                if (t) {
                    const cellIndex = t.cellIndex;
                    // console.log(cellIndex);
    
                    let selectCell = myTable.querySelector("td[data-index='"+cellIndex+"']");
                    selectCell.classList.add("clicked");
                    
                    let selectSpan = myTable.querySelector("td[data-index='"+cellIndex+"'] .sg-radio");
                    
                    let targetID = modal.openedBy.parentElement.parentElement.querySelector("input[value='"+selectSpan.getAttribute("data-size")+"']").id;

                    document.getElementById(targetID).click();
                    
                }
                return false;
            }
        };
        for (let event in events) {
            myTable.addEventListener(event, events[event]);
        }

        /* add current class */
        
        let currentSelected = modal.openedBy.parentElement.parentElement.querySelector("input:checked");
        if (currentSelected) {
            console.log(currentSelected.value);
            let allIndexCells = myTable.querySelectorAll("td[data-index]");
            for (let i = 0, n = allIndexCells.length; i < n; i++) {
                allIndexCells[i].classList.remove("clicked");
            }
            let selectCell = myTable.querySelector("td[data-size='"+currentSelected.value+"']");
            selectCell.classList.add("clicked");
        }
    }
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    sizeGuideInit(this);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      var slideid = this.getAttribute('data-slideid');

      if (modal) modal.show(button);
      if (slideid) {
        slideid = parseInt(slideid, 10);
        // slideid = slideid - 1;
        var selector = "slider-component button[data-position='"+slideid+"']";
        let clicbtn = document.querySelector(selector);
        clicbtn.click();
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.currentPageDotElement = this.querySelector('.slider-dots');
    this.sliderDots = this.querySelectorAll('button.slide-precise');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.animating = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.sliderDots.forEach(sliderDot => sliderDot.addEventListener('click', this.onDotClick.bind(this)) );
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    // console.log('sliderItemsToShow '+this.sliderItemsToShow);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // console.log('sliderItemOffset '+this.sliderItemOffset);
    this.slidesPerPage = Math.round((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    // console.log('clientWidth '+this.slider.clientWidth);
    // console.log('offsetLeft '+this.sliderItemsToShow[0].offsetLeft);
    // console.log('slidesPerPage '+this.slidesPerPage);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.totalPages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPageDotElement) {
        let currentPageforDot = 1;
        let pagingwidth = this.slidesPerPage * this.sliderItemOffset;
        let remdiv = this.slider.scrollLeft % this.sliderItemOffset;
        let roundiv = Math.round(this.slider.scrollLeft / pagingwidth);
        let roundivoff = Math.round(this.slider.scrollLeft / this.sliderItemOffset);

        // console.log("pagingwidth: "+pagingwidth);
        // console.log("slidesPerPage: "+this.slidesPerPage);
        // console.log("sliderItemOffset: "+this.sliderItemOffset);
        // console.log("scrollLeft: "+this.slider.scrollLeft);
        // console.log("remdiv: "+remdiv);
        // console.log("roundiv: "+roundiv);
        // console.log("roundivoff: "+roundiv);
        // console.log("this.sliderItemsToShow.length: "+this.sliderItemsToShow.length);
        // console.log("this.totalPages: "+this.totalPages);
        // console.log("this.slidesPerPage: "+this.slidesPerPage);

        if ((this.slider.scrollLeft + 10) >= this.sliderItemOffset) {

            currentPageforDot = roundiv + 1;
        }

        // if (this.slider.scrollLeft > 10 && (this.slider.scrollLeft + 10) < pagingwidth) {
        //     currentPageforDot = this.totalPages;
        // }

        if ((this.sliderItemsToShow.length - (this.totalPages * this.slidesPerPage)) < 0) {
           // we have an odd numbered last page
            if ((roundivoff + this.slidesPerPage) == this.sliderItemsToShow.length) {
                currentPageforDot = this.totalPages;
            }
        }


        if (currentPageforDot == 0) currentPageforDot = 1;


        this.currentPageDotElement.setAttribute("data-curr", currentPageforDot);
        this.currentPageDotElement.setAttribute("data-page", this.totalPages);
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft;
    // console.log((element.offsetLeft + element.clientWidth));
    // console.log(lastVisibleSlide);
    // console.log((element.offsetLeft + element.clientWidth) <= lastVisibleSlide);
    // console.log("---");
    // console.log(element.offsetLeft);
    // console.log(this.slider.scrollLeft);
    // console.log(element.offsetLeft >= this.slider.scrollLeft);
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onDotClick(event) {
    event.preventDefault();
    event.stopPropagation();

    let currStep = this.currentPageDotElement.getAttribute("data-curr");
    let nextStep = event.target.getAttribute("data-position");
    let maxSteps = this.currentPageDotElement.getAttribute("data-page");
    let buttons = this.currentPageDotElement.querySelectorAll("button");

    currStep = parseInt(currStep, 10);
    nextStep = parseInt(nextStep, 10);
    maxSteps = parseInt(maxSteps, 10);
    
    if (nextStep == currStep) return;

    if (buttons.length != maxSteps) {
        // slider is reduced, change behaviour of dots
        // this.totalPages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);

        let pagesGone = this.slidesPerPage * (nextStep - 1);
        this.slideScrollPosition = pagesGone * this.sliderItemOffset;

        if ((nextStep * this.slidesPerPage) > this.sliderItemsToShow.length) {
            // last page has less, slide accordingly 
            this.slideScrollPosition = ((this.sliderItemsToShow.length - this.slidesPerPage) * this.sliderItemOffset);
        }

    } else {

        let step = Math.abs(currStep - nextStep);
    
        if (nextStep < currStep) {
            this.slideScrollPosition = this.slider.scrollLeft - (step * this.sliderItemOffset);
        } else {
            this.slideScrollPosition = this.slider.scrollLeft + (step * this.sliderItemOffset);
        }
        
    }

    // let step = Math.abs(currStep - nextStep);

    // if (nextStep < currStep) {
    //     this.slideScrollPosition = this.slider.scrollLeft - (step * this.sliderItemOffset);
    // } else {
    //     this.slideScrollPosition = this.slider.scrollLeft + (step * this.sliderItemOffset);
    // }

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    this.currentPageDotElement.setAttribute("data-curr", nextStep);
    // console.log("setting");
    // console.log(nextStep);
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productForms = document.querySelectorAll(`[id='product-form-${this.dataset.section}']`);
    const quantiConts = document.querySelectorAll(".quantity-pm-container");
    if (!productForms) return;

    productForms.forEach((productForm) => {
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    quantiConts.forEach((quantForm) => {
      if (disable) {
        quantForm.classList.add("oos");
        quantForm.classList.remove("noos");
      } else {
        quantForm.classList.add("noos");
        quantForm.classList.remove("oos");
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
          
          applyOpacityObs(this.querySelectorAll(".obs_opacity"));

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function updateHeadBotPos() {
    var propHeader = document.getElementById('shopify-section-header'),
        propAnnouncement = document.getElementById('shopify-section-announcement-bar'),
        headBottom = (parseInt(propHeader.getBoundingClientRect().bottom - 2) < 1) ? 0 : (parseInt(propHeader.getBoundingClientRect().bottom - 2)),
        headHeight = propHeader.clientHeight;
    
    if (propAnnouncement) {
        headHeight = headHeight + propAnnouncement.clientHeight;
    }

    document.documentElement.style.setProperty('--header-bottom-position', headBottom+`px`);
    document.documentElement.style.setProperty('--header-height', headHeight+`px`);
}

function headerResize() {
    updateHeadBotPos();
}
let bodyThrottleTimer;
function throttleBodyResize() {
    if (bodyThrottleTimer) return;
    bodyThrottleTimer = true;
    setTimeout(() => {
        bodyResize();
        bodyThrottleTimer = false;
    }, 100);
}
function bodyResize() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
}

try {
    var propHeader = document.getElementById('shopify-section-header');

    const headerObserver = new ResizeObserver(entries => headerResize());
    headerObserver.observe(propHeader);

    window.addEventListener("resize", throttleBodyResize);

    updateHeadBotPos();
    setTimeout(function() {
        updateHeadBotPos();
    },2500);

} catch(e) {
    // console.log("failed to set property");
}

function autoCloseFacets() {

}

document.querySelectorAll(".rte img:not(.obs_opacity)").forEach((rteImg) => {
    rteImg.classList.add("obs_opacity");
});

function applyOpacityObs(opacityItems) {
    var opacityObs = new IntersectionObserver(function(entries, obvserver) {
        function addRemoveIO(targetEl, addAR, removeAR) {
            addAR.forEach((className) => {targetEl.classList.add(className); });
            removeAR.forEach((className) => {targetEl.classList.remove(className); });
        }
        function removeArr(inInt) {
            let removeAr = [];
            [1,2,3,4,5].forEach((supInt) => { if (supInt != inInt) removeAr.push('in-view-'+supInt); });
            return removeAr;
        }
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.remove("out-view");
                entry.target.classList.add("in-view");
                if (entry.intersectionRatio > 0.2) {
                    addRemoveIO(entry.target, ['in-view-5'], removeArr(5));
                } else if (entry.intersectionRatio > 0.15) {
                    addRemoveIO(entry.target, ['in-view-4'], removeArr(4));
                } else if (entry.intersectionRatio > 0.1) {
                    addRemoveIO(entry.target, ['in-view-3'], removeArr(3));
                } else if (entry.intersectionRatio > 0.05) {
                    addRemoveIO(entry.target, ['in-view-2'], removeArr(2));
                } else {
                    addRemoveIO(entry.target, ['in-view-1'], removeArr(1));
                }
            } else {
                addRemoveIO(entry.target, ['out-view'], ["in-view", "in-view-1", "in-view-2", "in-view-3", "in-view-4", "in-view-5"]);
            }
        });
    }, {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.05, 0.1, 0.15, 0.2] 
    });
    opacityItems.forEach(opacityItem => opacityObs.observe(opacityItem));
}

applyOpacityObs(document.querySelectorAll(".obs_opacity"));

try {

    var checkForFacets = document.querySelectorAll(".facets-container details.mobile-facets__details");
    checkForFacets.forEach((detailsEl) => {
        detailsEl.addEventListener("toggle", (event) => {
            if (!detailsEl.classList.contains("quite-close")) {
                document.querySelectorAll(".facets-container details.mobile-facets__details[open]").forEach((detailsElReq) => {
                    if (!detailsEl.isSameNode(detailsElReq)) {
                        detailsElReq.classList.add("quite-close");
                        detailsElReq.removeAttribute("open");
                        detailsElReq.querySelector('summary').setAttribute('aria-expanded', false);
                        setTimeout(function () {
                            detailsElReq.classList.remove("quite-close");
                        }, 250);
                    }
                });
            }
        });
    });

} catch (e) {
    // console.log("facet failure");
}
